import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { IonicModule } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DistanceComponent } from './modals/distance/distance.component';
import { IdentityProviderLoginComponent } from './modals/identity-provider-login/identity-provider-login.component';
import { OtpVerifyComponent } from './modals/otp-verify/otp-verify.component';
import { PaymentButtonComponent } from './modals/payment-button/payment-button.component';
import { PrintOptionsComponent } from './modals/print-options/print-options.component';
import { TwoOptionsPopupComponent } from './modals/two-options-popup/two-options-popup.component';
import { UserLoginPage } from './modals/user-login/user-login.page';
import { UserTypeOptionsPage } from './modals/user-type-options/user-type-options.page';

const modals: any[] = [
  UserTypeOptionsPage,
  UserLoginPage,
  PrintOptionsComponent,
  TwoOptionsPopupComponent,
  IdentityProviderLoginComponent,
  OtpVerifyComponent,
  PaymentButtonComponent,
  DistanceComponent,
];

@NgModule({
  declarations: [...modals],
  imports: [CommonModule, SharedModule, IonicModule],
  providers: [provideHttpClient()],
})
export class CoreModule {
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule,
    private translateService: TranslateService
  ) {
    if (parentModule) {
      throw new Error(
        this.translateService.instant('COREMODULE_HAS_ALREADY_BEEN_LOADED')
      );
    }
  }
}
